import {
  getDataAsync,
  putDataAsync,
  deleteDataAsync,
  postDataAsync,
} from "./PortalApi";
import UpdateCurrentUserRequest from "interfaces/request/UpdateCurrentUserRequest";
import CurrentUserResponse from "interfaces/response/CurrentUserResponse";
import UserPhoneUpdateRequest from "interfaces/request/UserPhoneUpdateRequest";
import UserEmailUpdateRequest from "interfaces/request/UserEmailUpdateRequest";

export const getCurrentUserDetailAsync = () => {
  const url = "Users/Details";
  return getDataAsync<CurrentUserResponse>(url);
};

export const updateUserDetail = async (
  userId: number,
  data: UpdateCurrentUserRequest
) => {
  const routeUrl = `Users/${userId}`;
  return await putDataAsync<UpdateCurrentUserRequest, CurrentUserResponse>(routeUrl, data);
};

export const deleteUserAsync = async (userId: number) => {
  const routeUrl = `Users/${userId}`;
  return await deleteDataAsync(routeUrl);
};

export const requestForUserPhoneUpdateAsync = async (
  userId: number,
  data: UserPhoneUpdateRequest
) => {
  const routeUrl = `Users/${userId}/Phone`;
  return await postDataAsync<UserPhoneUpdateRequest, CurrentUserResponse>(
    routeUrl,
    data
  );
};

export const requestForUserEmailUpdateAsync = async (
  userId: number,
  data: UserEmailUpdateRequest
) => {
  const routeUrl = `Users/${userId}/Email`;
  return await postDataAsync<UserEmailUpdateRequest, CurrentUserResponse>(
    routeUrl,
    data
  );
};
